import { useTranslation } from 'react-i18next';
import { AlwaysIncluded } from '../shared/AlwaysIncluded';
import layout from '../shared/checkoutLayout.module.scss';
import { currency } from '../shared/data';
import { NoticeList, PaymentMethods } from '../shared/primitives';
import { TrustBox } from '../shared/TrustBox';
import { useAppSelector } from '../store/hooks';
import { trialAlwaysIncluded } from './data';
import styles from './TrialOrderSummary.module.scss';
import type { TrialView } from './trialSelectors';

const formatDueDate = (date: Date) =>
  date.toLocaleString('en-GB', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  });

export function TrialOrderSummary({ view }: { view: TrialView }) {
  const { t } = useTranslation();
  const localization = useAppSelector((state) => state.app.localization);
  const currencySymbol = localization?.currencySymbol ?? '';
  const dueDate = view.dueDate ? formatDueDate(view.dueDate) : '';

  return (
    <aside className={layout.summary}>
      <NoticeList />
      <div className={layout.summaryBox}>
        <div className={layout.summaryTitle}>{t('Order summary')}</div>

        <div className={styles.product}>{view.name}</div>

        <div className={styles.trialBox}>
          <div className={styles.trialRow}>
            <span className={styles.trialPeriod}>
              {t('{{name}} {{days}}-day free trial ends', {
                name: view.name,
                days: view.trialDays,
              })}
            </span>
          </div>
          <div className={styles.trialRow}>
            <span className={styles.trialDue}>
              {t('Due {{date}}', { date: dueDate })}
            </span>
            <span className={styles.trialPrice}>
              {currencySymbol} {currency(view.sourcePrice)}
            </span>
          </div>
          <div className={styles.trialRow}>
            <span />
            <span className={styles.trialTaxes}>{t('+ taxes')}</span>
          </div>
        </div>

        <div className={styles.payNow}>
          <span className={styles.payNowLabel}>{t('Pay Now')}</span>
          <span className={styles.payNowValue}>{currencySymbol} 0</span>
        </div>

        <div className={styles.terms}>
          <div className={styles.termsTitle}>{t('Free trial terms')}</div>
          <div>
            {t('Billing starts automatically after the free trial ends.')}
          </div>
          <div>
            {t('Cancel before {{date}} to avoid getting billed.', {
              date: dueDate,
            })}
          </div>
        </div>

        <PaymentMethods />
        <AlwaysIncluded items={trialAlwaysIncluded} />
      </div>

      <TrustBox />
    </aside>
  );
}
